import { Dispatch } from '../../../../../core';
import { statusDispatch } from '../../../../../core/configs/state-dispatches.config';
const iconsOfActionsList22 = [
  {
    iconSVG: 'check-circle-regular',
    hasVisibleCondition: (row: Dispatch): boolean => {
      if (row) {
        if (typeof (row.dispatchItems) === 'object') {
          if ((row.dispatchItems.canceledAmount === row.dispatchItems.pendingAmount)
            || row.dispatchItems.pendingAmount === 0) {
            return false;
          } else {
            return true;
          }
        }
      }
      return true;
    }
  },
  {
    iconSVG: 'cancel',
    hasVisibleCondition: (element: Dispatch): boolean =>{
      return element
      && element.dispatchItems
      && element.dispatchItems.pendingAmount !== 0
      && element.dispatchItems.canceledAmount !== element.dispatchItems.pendingAmount
      ?
      element.dispatchItems.state === statusDispatch.PENDING_PICKING
      && element.dispatchItems.currentPickingSystem
      && element.dispatchItems.currentPickingSystem !== ''
      && element.dispatchItems.currentPickingSystem === element.dispatchItems.availablePickingSystem
      : false;
    }
  }
];


export const confirmationDispatchesMobile = {
  expandable: false,
  expandableType: '',
  detailQuantity: false,
  footerAction: false,
  iconFooter: iconsOfActionsList22,
  checkboxIcon: [],
  items: [
    {
      title: 'N° de despacho',
      name: 'dispatchId',
      class: 'col-12',
      icon: 'photo',
      value: (element: Dispatch) => element.dispatchId
    },
    {
      title: 'Descripción',
      name: 'skuName',
      class: 'col-12',
      value: (element: Dispatch) => element.dispatchItems.skuName
    },
    {
      title: 'Código SKU',
      name: 'skuCode',
      class: 'col-4',
      value: (element: Dispatch) =>
        element.dispatchItems.skuCode + '-' + element.dispatchItems.skuPartialSequence
    },
    {
      title: 'Cant. Total',
      name: 'pendingAmount',
      class: 'col-4',
      value: (element: Dispatch) => element.dispatchItems.pendingAmount
    },
    {
      title: 'Cant. Cancelada',
      name: 'canceledAmount',
      class: 'col-4',
      value: (element: Dispatch) => (element.dispatchItems.canceledAmount != null) ? element.dispatchItems.canceledAmount : 0
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      class: 'col-6',
      value: (element: Dispatch) => element.deliveryDate
    },
    {
      title: 'Tipo de entrega',
      name: 'deliveryTypeName',
      class: 'col-6',
      value: (element: Dispatch) => element.deliveryTypeName
    }, /* ,
      {
        title: 'Ruta',
        name: 'route',
        class: 'col-12',
        value: (element: Dispatch) => element.route
      }, */
    {
      title: 'Estado',
      name: 'state',
      onFooter: true,
      value: (element: Dispatch) => element.dispatchItems.state
    }
  ]
};
